import React from "react";
// import Principal from "../components/Principal";
//import Login from "../pages/Login";
import Footer from "../components/Footer";
//import logo from "../images/distripollo.jpeg";
// import alumno from "../images/alumno.jpeg";
// import docente from "../images/avatardocente.png";
import remito from "../images/remito.png";
import remitoc from "../images/remitoc.png";
import gasto from "../images/gasto.png";
import egreso from "../images/egreso.png";
import cuota from "../images/cuota.jpg";
import ajuste from "../images/ajuste.jpg";
import rendicion from "../images/rendicion.png";
import orden from "../images/orden.png";
import cheque from "../images/cheque.png";
import tesoro from "../images/tesoro.png";
import { Navbar, Nav, NavDropdown } from "react-bootstrap";
import { Link, useLocation, useHistory } from "react-router-dom";
import "../css/homeimpresion.css";
import "../css/footer.css";

const HomeImpresion = () => {
  return (
    <>
      <div className="container mt-5">
        <hr />          
        <div className="row text-center mb-3">
          <div className="col-12">
            <h1>Informes Varios</h1>
          </div>
        </div>

        <div className="row mb-5 mt-5">
          <div className="row-iconos">

            <div className="col-icono">
              <Link to="/informeremitos" className="custom-link">
                <img src={remito} alt="icono viajes" />
                <h3>Remitos</h3>
              </Link>
            </div>

            <div className="col-icono">
              <Link to="/informeremitocs" className="custom-link">
                <img src={remitoc} alt="icono viajes" />
                <h3>R. Campo</h3>
              </Link>
            </div>

            {/* <div className="col-icono">
              <Link to="/informecomandas" className="custom-link">
                <img src={gasto} alt="icono viajes" />
                <h3>Viajes</h3>
              </Link>
            </div> */}

            <div className="col-icono">
              <Link to="/informecajas" className="custom-link">
                <img src={cuota} alt="icono cajas" />
                <h3>Cajas</h3>
              </Link>
            </div>

            <div className="col-icono">
              <Link to="/informemovimientos" className="custom-link">
                <img src={egreso} alt="icono cajas" />
                <h3>Movimientos</h3>
              </Link>
            </div>
            {/* <div className="col-icono">
              <Link to="/informerendiciones" className="custom-link">
                <img src={rendicion} alt="icono cajas" />
                <h3>Rendiciones</h3>
              </Link>
            </div> */}
            <div className="col-icono">
              <Link to="/informeordencobro" className="custom-link">
                <img src={orden} alt="icono cajas" />
                <h3>Ordenes Cobro</h3>
              </Link>
            </div>
            <div className="col-icono">
              <Link to="/informeordenpago" className="custom-link">
                <img src={orden} alt="icono cajas" />
                <h3>Ordenes Pago</h3>
              </Link>
            </div>
            <div className="col-icono">
              <Link to="/informecartera" className="custom-link">
                <img src={cheque} alt="icono cajas" />
                <h3>Cartera Cheque</h3>
              </Link>
            </div>
            <div className="col-icono">
              <Link to="/informe-cheques-echeq" className="custom-link">
                <img src={cheque} alt="icono cajas" />
                <h3>Resumenes Cheque/Echeq</h3>
              </Link>
            </div>
            <div className="col-icono">
              <Link to="/informeclipro" className="custom-link">
                <img src={tesoro} alt="icono cajas" />
                <h3>Saldos Cliente/Proveedor</h3>
              </Link>
            </div>

            <div className="col-icono">
              <Link to="/informeajustesctacte" className="custom-link">
                <img src={ajuste} alt="icono cajas" />
                <h3>Ajustes Cta Cte</h3>
              </Link>
            </div>

            <div className="col-icono">
              <Link to="/informectacte" className="custom-link">
                <img src={tesoro} alt="icono cajas" />
                <h3>Ctas Ctes Cliente/Proveedor</h3>
              </Link>
            </div>


            {/* <div className="col-icono">
              <Link to="/informetesoreria" className="custom-link">
                <img src={tesoro} alt="icono cajas" />
                <h3>Tesoreria</h3>
              </Link>
            </div> */}

          </div>
        </div>
          
      </div>


      <Footer />
    </>
  );
};

export default HomeImpresion;

        // <div className="row mb-5 mt-5">
          {/* <div className="col-3 mb-5 mt-5">
            <Link className="nav" to="/informealumnos">
              <div className="box-wrapper color-alumno">
                <img className="logo" src={alumno} alt="logo" href="/clientes" />
                <Navbar.Brand className="mt-3 ml-3">
                  <h3 className="h3">Alumnos</h3>
                </Navbar.Brand>
                </div>
            </Link>
          </div> */}
          
          {/* <div className="col-3 mb-5 mt-5">
            <Link className="nav" to="/informedocentes">
              <div className="box-wrapper color-docente">
                <img className="logo" src={docente} alt="logo" href="/clientes" />
                <Navbar.Brand className="mt-3 "></Navbar.Brand>
                <h3 className="h3">Docentes</h3>
              </div>
            </Link>
          </div> */}


          {/* <div className="col-3 mb-5 mt-5">
            <Link className="nav" to="/informegastos">
              <div className="box-wrapper color-gasto">
                <img className="logo" src={gasto} alt="logo" href="/clientes" />
                <Navbar.Brand className="mt-3 "></Navbar.Brand>
                <h3 className="h3">Gastos</h3>
              </div>
            </Link>
            </div> */}

          {/* <div className="col-3 mb-5 mt-5">
            <Link className="nav" to="/informeegresos">
              <div className="box-wrapper color-cuota">
                <img className="logo" src={egreso} alt="logo" href="/clientes" />
                <Navbar.Brand className="mt-3 "></Navbar.Brand>
                <h3 className="h3">Egresos $</h3>
              </div>
            </Link>
          </div> */}

        // </div>